<template>
  <el-dialog title="提示" :visible.sync="form.diglogStatus" width="580px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
    <h1 class="overdueClass">
      <i class="el-icon-warning"></i>
      <span>抱歉，你的账号已到期，已暂停使用，请前往后台续费套餐，恢复正常运营!</span>
      <label>官方客服热线：400 555 4444</label>
    </h1>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="jumpPage(1)">前往续费</el-button>
      <el-button type="primary" @click="jumpPage(2)">联系客服</el-button>
      <el-button @click="outLogin">退出登录</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getOutLogin, getErpLoginUrl } from './api/index';

export default {
  data() {
    return {
      form: {
        diglogStatus: false,
        url: '',
        days: ''
      }
    };
  },
  created() {
    const vm = this;
    vm.$emit('deadlineData', vm.form);
  },
  methods: {
    jumpPage(val) {
      if (val == 1) {
        window.open(this.form.url);
      } else {
        window.open('http://wpa.qq.com/msgrd?v=3&uin=2853821200&site=qq&menu=yes');
      }
    },
    // 退出
    outLogin() {
      getOutLogin().then((response) => {
        if (response.code == 0) {
          getErpLoginUrl().then((res) => {
            if (res.code == 0) {
              localStorage.clear();
              sessionStorage.clear();
              window.location.href = `${res.data}/jsp/login/out/exit.html?proIDen=5EEx+rTdFv/5kj/TK0A9DJ5xUSmGIq+E`;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error(response.msg);
        }
      });
    },
  }
};
</script>

<style>
.overdueClass {
    height: 40px;
    padding-bottom: 100px;
}
.overdueClass i {
    font-size: 35px;
    color: #f7ba2a;
    float: left;
    padding-right: 10px;
}
.overdueClass span {
    display: block;
    height: 17px;
    line-height: 15px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
}
.overdueClass label {
    display: block;
    height: 18px;
    line-height: 18px;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}
</style>
